import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const venueApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getVenue: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
        type: string;
        status: any
        country?: string
      }
    >({
      query: ({ page, limit, search, type, status, country }) => ({
        url:
          `${END_POINTS.venueStorage}?from=${page}&size=${limit}&status=${status}` +
          (type?.length ? `&type=${type}` : "") + (country?.length ? `&country=${country}` : "") +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),

    getVenueStorage: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
        type: string;
        status: string;
        country?: string
      }
    >({
      query: ({ page, limit, search, type, status,country }) => ({
        url:
          `${END_POINTS.getVenueStorage}?from=${page}&size=${limit}` +
          (type?.length ? `&type=${type}` : "") +
          (search?.length ? `&search=${search}` : "") +
          (status ? `&status=${status}` : "") + (country?.length ? `&country=${country}` : ""),
        method: "GET",
      }),
    }),

    changeVenueStorageStatus: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.changeVenueStorageStatus}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteVenue: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteVenueStorage}/${id}`,
        method: "DELETE",
      }),
    }),

    addVenue: builder.mutation<CommonResponseType & { data: any }, any>({
      query: (body) => ({
        url: `${END_POINTS.addVenue}`,
        method: "POST",
        body,
      }),
    }),

    getVenueDetails: builder.query<
      CommonResponseType & {
        data: any;
      },
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getVenueStorage}/${id}`,
        method: "GET",
      }),
    }),

    updateVenueStorage: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.getVenueStorage}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    acceptRejectVenueStorage: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.acceptRejectVenueStorage}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    venueExport: builder.query<
      CommonResponseType & {
        data: any;
      },
      { type: string }
    >({
      query: ({ type }) => ({
        url: `${END_POINTS.exportVenueStorage}?type=${type}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetVenueQuery,
  useGetVenueQuery,
  useLazyGetVenueStorageQuery,
  useChangeVenueStorageStatusMutation,
  useAcceptRejectVenueStorageMutation,
  useDeleteVenueMutation,
  useAddVenueMutation,
  useLazyGetVenueDetailsQuery,
  useUpdateVenueStorageMutation,
  useLazyVenueExportQuery,
} = venueApi;
